import { Component, inject, Input } from '@angular/core';

import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { XwaiV2StreamService } from '../stream/xwai-v2-stream.service';
import { XwaiV2StreamComponent } from '../stream/xwai-v2-stream.component';
import { XwaiInputComponent } from '../xwai-input/xwai-input.component';
import { XwaiSidebarComponent } from '../xwai-sidebar/xwai-sidebar.component';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NzSpinComponent } from 'ng-zorro-antd/spin';

@Component({
  selector: 'app-xwai-v2-shell',
  imports: [
    NzLayoutModule,
    XwaiV2StreamComponent,
    XwaiInputComponent,
    XwaiSidebarComponent,
    NzDropDownModule,
    NzButtonComponent,
    NzIconModule,
    NzTooltipModule,
    NzSpinComponent
],
  templateUrl: './xwai-v2-shell.component.html',
  styleUrls: ['./xwai-v2-shell.component.less']
})
export class XwaiV2ShellComponent {
  // Root-scoped streaming service — same instance the embedded
  // <app-xwai-v2-stream> and <app-xwai-input> use, so they share one conversation.
  private service = inject(XwaiV2StreamService);
  // Widens the reading column (see .less) and, while embedded, doubles as the
  // sidebar's collapse/expand state: collapsed rail when narrow, full rail
  // when expanded — see the `lockedCollapsed` binding in the template.
  @Input() expanded = false;

  // True when embedded in the floating model-ai-panel. Locks app-xwai-sidebar
  // to `!expanded` and hides its own trigger there, so the panel's expand
  // button is the only toggle — driving both the reading width and the
  // sidebar in one control. The standalone /xwai-v2 route leaves this false
  // and keeps the sidebar's normal, independently-clickable collapse trigger.
  @Input() embedded = false;

  readonly threadId = this.service.threadId;
  readonly activeConversation = this.service.activeConversation
  readonly messages = this.service.messages
  readonly isLoading = this.service.isLoading
  readonly initialising = this.service.initializing
  
  protected downloadHistory() {
    this.downloadFile(
      JSON.stringify(this.messages(), null, 2),
      'conversation.json',
      'application/json',
    );
  }

  protected exportMarkdown(){
    const title = "XWAI conversation";
    const lines: string[] = [`# ${title}`, ""];

    for (const msg of this.messages()) {
      const who = msg.role === "user" ? "You" : "XWAI";
      lines.push(`**${who}:**`, "");
      if (typeof msg.content === "string") {
        lines.push(msg.content, "");
      } else {
        lines.push(`_[interactive ${msg.role} visualization]_`, "");
      }
    }

    this.downloadFile(lines.join("\n"), "xwai_conversation.md", "text/markdown");
  }

  private downloadFile(content: string, filename: string, type: string) {
    const blob = new Blob([content], { type });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a); // Clean up the element
    URL.revokeObjectURL(url);
  }
}
